const state = {
    loading: false,
    error: null,
    activeSection: "",
    activeUser: null,
    activeProjectList: null,
    notifications: [],
    title: "",
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setError(state, error) {
        state.error = error;
    },

    setActiveSection(state, activeSection) {
        state.activeSection = activeSection;
    },

    setActiveUser(state, activeUser) {
        state.activeUser = activeUser;
        state.notifications = [];

        activeUser.pending_class_comments.forEach((c) => {
            state.notifications.push({
                text: "Novo comentário no curso <strong>" + c.title + "</strong>.",
                link: "/curso/" + c.id + "/" + c.course_class_id,
                registration_timestamp: c.registration_timestamp
            });
        });

        activeUser.pending_video_comments.forEach((c) => {
            state.notifications.push({
                text: "Novo comentário na aula <strong>" + c.title + "</strong>.",
                link: "/video/" + c.id,
                registration_timestamp: c.registration_timestamp
            });
        });

    },

    setActiveProjectList(state, activeProjectList) {
        state.activeProjectList = activeProjectList;
    }
};

const getters = {}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions
}